<template>
  <div class="account-info-widget-component">
     <template>
      <div v-if="!isLoggedIn" class="login-info">
        <v-btn v-if="!mobileBigAndBelow" class="login_btn" @click="openDialogLogin()"><span>{{ $t('MyAccount.LogIn') }}</span></v-btn>
        <v-btn v-if="!mobileBigAndBelow" class="btn join" @click="goToRegistrationPage()"><span>{{ $t('MyAccount.JoinNow') }}</span></v-btn>
        <v-btn :ripple="false" v-if="mobileBigAndBelow" class="account_btn" @click="openDialogLogin()"><span class="pd-icon pd-icon-player-icon-not-loggedin"></span></v-btn>
        <v-dialog content-class="dialog-login expand" v-model="dialogLogin" persistent :fullscreen="mobileBigAndBelow" :hide-overlay="mobileBigAndBelow">
          <login-component v-if="dialogLogin"></login-component>
        </v-dialog>
        <v-dialog :content-class="dialogMyaccount" v-model="dialogMyAccount" persistent v-if="mobileBigAndBelow" fullscreen hide-overlay transition="dialog-bottom-transition">
          <login-component v-if="dialogMyAccount && mobileBigAndBelow"></login-component>
        </v-dialog>
      </div>
      <div class="sessionDetails" v-if="tabletAndAbove && isLoggedIn">
        <span class="lastlogin"><span key="last_login">{{ $t('MyAccount.LastLogin') }}</span> {{ lastLogin || '--' }}</span>
        <span><span key="session_duration">{{ $t('MyAccount.SessionDuration') }}</span> {{ sessionTime }}</span>
      </div>
      <div v-if="isLoggedIn" class="account-info">
        <v-btn v-if="tabletAndAbove" class="my_profile" @click="goToProfile()">
          <span class="pd-icon pd-icon-lottery-notifications"></span>
          {{ personalDetails && personalDetails.FirstName }} {{ personalDetails && personalDetails.LastName && personalDetails.LastName[0] }}.
        </v-btn>
        <v-dialog content-class="dialogMyAccountDesktop" width="450" v-model="dialogMyAccountDesktop"  v-if="!mobileBigAndBelow && isLoggedIn" transition="dialog-right-transition">
          <div class="account_desktop">
            <div class="account_details">
              <div class="user_details">
                <div class="user_image">
                  <span class="pd-icon pd-icon-player-icon"></span>
                </div>
                <span class="user_title">{{ personalDetails && personalDetails.FirstName }} {{ personalDetails && personalDetails.LastName && personalDetails.LastName[0] }}.</span>
                <div class="session_details">
                  <div class="lastlogin"><span class="lastlogdur">{{ $t('MyAccount.LastLoggedIn') }}</span> <span>{{lastLogin || '--' }}</span></div>
                  <div><span key="session_info_duration" class="lastlogdur">{{ $t('MyAccount.SessionDuration') }}</span> <span>{{sessionTime}}</span></div>
                </div>
              </div>
              <!-- <account-info-component></account-info-component> -->
              <div class="account_balance">
                <div class="show_hide" @click.stop="toggleShowBalance(showBalance)">
                  <span>
                    {{ showBalance ? 'Hide' : 'Show' }}
                  </span>
                </div>
                <div class="balace_bonus" v-if="showBalance">
                  <div class="balance">
                    <span class="text" key="current_balance">{{ $t('MyAccount.CurrentBalance') }}</span>
                    <span class="value" @click="getWalletBalance()">{{ totalCacheBalance | currency }}</span>
                  </div>
                  <div class="bonus">
                    <span class="text" key="sportsbook_bonus">{{ $t('MyAccount.SportsbookBonus') }}</span>
                    <span class="value" @click="getWalletBalance()">{{ siteCreditBalance | currency }}</span>
                  </div>
                </div>
              <div class="buttons">
                <v-btn class="primary-btn deposit" @click.stop="addFundsRedirect('deposit')" :class="{'depositDisabled': (!isOpenedFromWebView && !webViewAndMobile) && !isGeolocated}"><span>{{ $t('MyAccount.Deposit') }}</span></v-btn>
                <v-btn class="primary-btn withdraw" @click.stop="addFundsRedirect('withdraw')"><span>{{ $t('MyAccount.Withdraw') }}</span></v-btn>
              </div>
            </div>
          </div>
          <div class="account_links">
            <site-navigation :navigation-section="'MY_ACCOUNT_LINKS'" class="account_links"></site-navigation>
          </div>
          </div>
        </v-dialog>
        <v-btn v-if="tabletAndAbove" class="primary-btn deposit balance-deposit" @click="goToProfile()">
        <!-- <v-btn  class="primary-btn deposit balance-deposit" :href="isOpenedFromWebView? externalUrls.addFunds + '?uiView=true': externalUrls.addFunds" target="_self"> -->
          <span class="balance" v-if="showBalance">
            <span class="value">{{ balanceSum | currency }}</span>
          </span>
          <span class="balance" v-if="!showBalance">
            <span class="span_balance_hidden" key="2">{{ $t('MyAccount.Deposit') }}</span>
          </span>
          <span class="pd-icon pd-icon-chevron-down"></span>
        </v-btn>
        <div v-if="mobileBigAndBelow" class="deposit balance-deposit mobile">
        <!-- <v-btn  class="primary-btn deposit balance-deposit" :href="isOpenedFromWebView? externalUrls.addFunds + '?uiView=true': externalUrls.addFunds" target="_self"> -->
          <span class="balance" v-if="showBalance">
            <span class="value" @click="getWalletBalance() ">{{ balanceSum | currency }}</span>
          </span>
        </div>
        <v-btn v-if="!mobileBigAndBelow" class="logout_btn" @click="logOut()"><span class="pd-icon pd-icon-sign-out"></span></v-btn>
        <v-dialog content-class="dialog-myaccount" v-model="dialogMyAccount" persistent v-if="mobileBigAndBelow" fullscreen hide-overlay transition="dialog-bottom-transition">
          <div class="account_mobile">
            <div class="account_details">
              <account-info-component></account-info-component>
              <v-layout class="buttons">
                <v-flex xs6>
                  <v-btn class="primary-btn deposit" @click.stop="addFundsRedirect('deposit')"><span>{{ $t('MyAccount.Deposit') }}</span></v-btn>
                </v-flex>
                <v-flex xs6>
                  <v-btn class="primary-btn withdraw" @click.stop="addFundsRedirect('withdraw')"><span>{{ $t('MyAccount.Withdraw') }}</span></v-btn>
                </v-flex>
              </v-layout>
          </div>
          <div class="account_links">
            <site-navigation :navigation-section="'MY_ACCOUNT_LINKS'" class="account_links"></site-navigation>
          </div>
          </div>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
  import store from '@/store'
  import config from '@/config'

  import LoginComponent from '@/components/core/LoginComponent'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import AccountInfoComponent from '@/components/horses/account/AccountInfoComponent'
  import Screen from '@/components/mixins/Screen'
  import Time from '@/components/mixins/Time'

  import Icon from '@/components/common/Icon'

  export default {
    name: 'AccountInfoWidgetComponent',

    mixins: [
      Screen,
      Time
    ],

    data () {
      return {
        sessionTime: 0
      }
    },

    components: {
      SiteNavigation,
      LoginComponent,
      AccountInfoComponent,
      Icon
    },

    computed: {
      externalUrls () { return config.externalUrls },
      dateFormats () { return config.app.dateFormats },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      dialogMyAccount () {
        return store.getters['overlayState/getMyAccountDialogState']
      },
      walletBalances () {
        return store.getters['getWalletBalance']
      },
      balanceSum () {
        return this.siteCreditBalance + this.totalCacheBalance
      },
      siteCreditBalance () {
        let balance = this.walletBalances && this.walletBalances.balances && this.walletBalances.balances.filter(balance => balance.type === 'AVAILABLE_BONUS')
        return (balance && balance[0] && balance[0].amount) || 0
      },
      totalCacheBalance () {
        let balance = this.walletBalances && this.walletBalances.balances && this.walletBalances.balances.filter(balance => balance.type === 'RM')
        return (balance && balance[0] && balance[0].amount) || 0
      },
      showBalance () {
        return store.getters['getShowBalance']
      },
      // showBalance: {
      //   get: () => {
      //     return store.getters['overlayState/getShowBalance']
      //   },
      //   set: (newValue) => {
      //     if (newValue) {
      //       store.dispatch('overlayState/setShowBalance', true)
      //     } else {
      //       store.dispatch('overlayState/setShowBalance', false)
      //     }
      //   }
      // },
      dialogLogin: {
        get: () => {
          return store.getters['overlayState/getLoginDialogState']
        },
        set: (newValue) => {
          if (newValue) {
            store.dispatch('overlayState/activateLoginDialog')
          } else {
            store.dispatch('overlayState/deactivateLoginDialog')
          }
        }
      },
      dialogMyAccountDesktop: {
        get: () => {
          return store.getters['overlayState/getMyAccountDesktopDialogState']
        },
        set: (newValue) => {
          if (newValue) {
            store.dispatch('overlayState/activateMyAccountDesktopDialog')
          } else {
            store.dispatch('overlayState/deactivateMyAccountDesktopDialog')
          }
        }
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      dialogMyaccount () {
        if (store.getters['isLoggedIn'] === true) {
          return 'dialog-myaccount'
        } else {
          return 'dialog-myaccount notLoggedIn'
        }
      },
      personalDetails () {
        return store.getters['getPersonalDetails']
      },
      igtcLastLoginDetails () {
        return store.getters['getIgtcLastLoginDetails']
      },
      lastLogin () {
        if (config.app.autoconf.EXTERNAL_WALLET_PROVIDER === 'IGTC') {
          var igtcLastLoginDate = this.igtcLastLoginDetails && this.igtcLastLoginDetails.loginDate

          if (igtcLastLoginDate) {
            let timeStr = this.dateToLocaleDatetimeString(new Date(igtcLastLoginDate), this.dateFormats.longDateTime)
            return timeStr
          } else {
            return 0
          }
        } else {
          var sessionDetails = config.customCookies.getCookie('sessionDetails')
          var lastLoginDate = (this.sessionDetails && (this.sessionDetails.lastlogin || this.sessionDetails.lastLoginDate)) ||
            (sessionDetails && (sessionDetails.lastlogin || sessionDetails.lastLoginDate))

          return (lastLoginDate && this.dateToLocaleDatetimeString(new Date(lastLoginDate), this.dateFormats.longDateTime))
        }
      },
      device (getters) {
        let device = ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || this.isOpenedFromWebView === true) ? 'MOBILE' : 'PORTAL'
        return device
      },
      cachierUrl () {
        return window.ctsautoconf.CACHIER_URL
      },
      cachierParams () {
        return window.ctsautoconf.CACHIER_PARAMS
      },
      isGeolocated () {
        var isGeolocated = store.getters['getGeolocated']
        return typeof isGeolocated !== 'undefined' ? JSON.parse(isGeolocated) : false
      },
      webViewAndMobile () {
        return store.getters['getWebViewAndMobile']
      }
    },

    methods: {
      logOut () {
        this.$router.push({name: 'logout', params: {}})
        // store.dispatch('logout')
      },
      goToProfile () {
        // this.$router.push({name: 'accountx', params: {}})
        store.dispatch('overlayState/activateMyAccountDesktopDialog')
      },
      openDialogLogin () {
        store.dispatch('overlayState/activateLoginDialog')
      },
      closeDialogLogin () {
        store.dispatch('overlayState/deactivateLoginDialog')
      },
      addFundsRedirect (action) {
        if ((!this.isGeolocated && this.isOpenedFromWebView) && action === 'deposit') {
          store.commit('overlayState/setMessageDialogMsg', {reason: 'native-failed-geolocation', persistent: true, fullscreen: false, action: action})
          store.dispatch('overlayState/activateMessageDialog')
          return false
        }
        if ((!this.isOpenedFromWebView && !this.webViewAndMobile) && !this.isGeolocated) {
          return false
        }
        store.dispatch('getOnePayToken').then(() => {
          var token = encodeURIComponent(store.getters['getOnePayTokenValue'])
          let isMobile = (this.device !== 'MOBILE') ? '&portalURL=' + window.location.href + '&onepayMode=' + this.cachierParams.onepayMode : ''
          let url = this.cachierUrl + '/?tempSessionId=' + token + '&platform=' + this.device.toLowerCase() + '&cashierSystemId=' + this.cachierParams.cashierSystemId + '&sentFromHome=' + this.cachierParams.sentFromHome + isMobile
          this.redirect(url)
        }).catch(() => {
          console.log('getOnePayToken error')
        })
      },
      toggleShowBalance (value) {
        if (value) {
          store.commit('setShowBalance', false)
        } else if (!value) {
          store.commit('setShowBalance', true)
        }
      },
      goToRegistrationPage () {
        this.$router.push({name: 'account-register'})
      },
      getWalletBalance () {
        store.dispatch('getWalletBalance')
      },
      redirect (url) {
        window.location.href = url
        return false
      }
    },
    created () {
      setInterval(() => {
        let value = Math.round(Math.abs(localStorage.loginTime - Date.now()) / 1000)
        if (value >= 0) {
          let minutes = Math.floor(value / 60)
          let seconds = value - minutes * 60
          seconds = (seconds < 10 ? ('0' + seconds) : seconds)
          minutes = (minutes < 10 ? ('0' + minutes) : minutes)
          this.sessionTime = `${minutes}:${seconds}`
        }
      }, 1000)
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/css/config'
  @import '~@/css/mixins'

  .login-info
    height: 100%
    display: flex
    align-items: center
    justify-content: flex-end

  .join
    color: #ffffff
    font-size: 14px
    font-weight bold
    font-style: normal
    font-stretch: normal
    line-height: normal
    background-color: #3FC369
    min-width: 76px

    @media mobile-big-and-below
      min-width: 75px
      height: 32px
      font-size: 14px

  .login_btn
    color: #fff
    font-size: 14px
    font-weight bold
    background-color: transparent !important
    min-width: auto
    width: auto
    margin-right: -6px

    @media mobile-big-and-below
      margin: 0
      min-width: 60px
      font-size: 14px
      font-weight: 600

    &.btn__content
      font-weight: 500 !important

  .menu
    >>> .menu__activator .btn__content
      color: #E5E5E5

  >>>.menu__content
    min-width: 320px !important

  .account-info-widget-component
    order: 2
    flex-grow: 1
    font-family: font-family-igt
    .btn--flat
      border-radius: 4px
    .account-info
      min-width: 320px
      text-align: right
      .deposit
        background: #FFFFFF
        background-color: #FFFFFF !important
        font-size: 16px
        font-weight: bold
        position: relative
        width: auto
        .balance
          line-height: 14px
          text-align: right
          margin-right: 12px
          .value
            color: #1493FF
            @media mobile-big-and-below
              color: #FFFFFF
        .btn__content span
          font-weight: normal !important
          color: #06283b
          @media mobile-big-and-below
            color: #CFD6DB
        .igt-icon
          right: 12px
          padding-right: 0
          >>> .icon-plus-circle-2
            width: 20px
            height: 20px
        .span_balance
          font-family: font-family-igt
          text-transform: uppercase
          font-size: 12px
          display: block
        .span_balance_hidden
          font-size: 14px
          font-weight: bold
          text-transform: uppercase
        &:hover
          // background: #31568F !important
          opacity: 0.8


  .account_details
    padding: 16px 12px 10px
    background: #20385A
    color: #fff

  .account_links
    background: #fff

    >>>hr
      display: none

    >>>.expansion-panel
      box-shadow: none

    >>>.expansion-panel__header
      height: 48px
      padding: 0 16px
      font-size: 14px
      color: #1f375b
      line-height: 48px
    >>>.expansion-panel__header .icon
      color: #1f375b !important

    .card__text
      background: #F5F8FC
      padding 0 16px

    .preferences
      border-bottom: 1px solid #CFD6DB
      margin: 0 -16px 0 -16px

    .preferences li
      display: flex
      height: 48px
      border-top: 1px solid #CFD6DB
      padding: 9px 16px
      line-height: 14px
      font-size: 12px
      span
        flex: 1 1 auto
        vertical-align: middle
      .switch
        margin-left: auto

      >>>.switch .input-group--selection-controls__container
        color: #2CB459 !important

      >>>.switch:not(.input-group--dirty) .input-group--selection-controls__container
         color: #CFD6DB !important

      >>>.input-group--selection-controls__toggle.input-group--selection-controls__toggle--active
        opacity: 1 !important
      >>>.input-group--selection-controls__ripple:after
        background: #fff
        margin-left: 4px
      >>>.input-group--selection-controls__ripple--active:after
       left: 30px

      .input-group
        min-width: auto
      >>>.input-group__input
        background: none !important
        padding: 0 0 0 12px !important
      >>>.input-group--selection-controls__toggle
        width: 50px
        height: 28px
        border-radius: 100px

  .primary-btn
    width: 144px
    border-radius: 4px

    .igt-icon
      padding-right: 8px

    @media mobile-big-and-below
      width: 98%

  .deposit
    background-color: #3fc369 !important
    color: #fff
    margin-left: 0

    &:hover
      background-color: #29974b !important
      border-radius: 2px
      
  .deposit.depositDisabled
    opacity: 0.6

  .withdraw
    background-color: #fff !important
    color: #06283b
    margin-left: 4px
    @media mobile-big-and-below
      color: #06283b

  .join_btn_mobile
    background-color: #fff !important
    color: #1F375B
    margin-left: -1px

  .login_btn_mobile
    background-color: #2396fc !important
    color: #fff
    margin-left: 4px

  .offer
    width: 100%
    height: 100px
    line-height: 100px
    text-align: center
    font-size: 20px
    background: #f5f5f5
    border-radius: 4px
    margin-bottom: 8px
    color: #20385a

  .igt-icon
    padding-right: 16px
    >>> .icon-add-funds
          width: 20px !important
          height: 20px !important

  .list
    padding: 0

    div:hover
      background: #F0F3F8 !important
      color: #2396FC
      cursor: pointer

    .list__tile__title
      font-size: 14px

@media mobile-big-and-below
  .account-info-widget-component
    .account-info
      min-width: auto !important
      .balance-deposit
        background: transparent !important
        margin-right: 0px
        font-size: 14px
        .igt-icon
          >>> .icon-plus-circle-2
            width: 28px
            height: 28px
        .balance
          margin-right : 10px
          line-height: 16px

</style>



// WEBPACK FOOTER //
// src/components/account/AccountInfoWidgetComponent.vue